import React from 'react';

interface NewTextFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const NewTextField: React.FC<NewTextFieldProps> = ({ id, label, value, onChange, placeholder }) => {
  const [isSelected, setIsSelected] = React.useState(false);
  const handleFocus = () => setIsSelected(true);
  const handleBlur = () => setIsSelected(false);

  return (
    <div className="new-text-field MuiFormControl-root MuiTextField-root textInput plainLabel">
      {
        (!value && !isSelected && false ) &&
        <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-filled MuiFormLabel-colorPrimary MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-filled" htmlFor={id}>
          {label}
        </label>
      }
      <div className="MuiInputBase-root MuiFilledInput-root MuiInputBase-colorPrimary MuiInputBase-formControl MuiInputBase-sizeSmall">
        <input
          aria-invalid="false"
          id={id}
          type="text"
          className="MuiInputBase-input MuiFilledInput-input MuiInputBase-inputSizeSmall"
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={label}
        />
      </div>
    </div>
  );
};

export default NewTextField;
